<template>
    <div>
        <el-row class="search-add" :gutter="10">
            <el-col :span="4">
                <el-input placeholder="设备编号" v-model="devId"></el-input>
            </el-col>
            <el-col :span="4">
                <el-input placeholder="SIM卡号" v-model="simId"></el-input>
            </el-col>
            <el-col :span="14">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <el-table-column prop="devId" label="设备编号">
            </el-table-column>
            <el-table-column prop="ccid" label="SIM1卡号">
            </el-table-column>
            <el-table-column prop="ccid1" label="SIM2卡号">
            </el-table-column>
            <el-table-column prop="imei" label="IMEI">
            </el-table-column>
            <el-table-column prop="imsi" label="IMSI1">
            </el-table-column>
            <el-table-column prop="imsi1" label="IMSI2">
            </el-table-column>
            <el-table-column prop="operate.name" label="运营商">
            </el-table-column>
            <el-table-column prop="termVersion" label="型号">
            </el-table-column>
            <el-table-column prop="lastReportTime" label="最后上报数据日期">
            </el-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        data() {
            return {
                data: [],
                devId:'',
                simId:'',
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                }
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    pageNum: this.pagin.pageNum,
                    pageSize: this.pagin.pageSize,
                }
                if(this.devId.trim() != '') {
                    params.devId = this.devId;
                }
                if(this.simId.trim() != '') {
                    params.simId = this.simId;
                }
                this.$http.post('/manage/sd/list', params).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
        },
        components: { Pagination }
    }
</script>